import { useQuery } from '@tanstack/react-query';
import { api } from '~/api/utils/api-base';
import { Tag } from '~/shared/types/tag';

export const useFetchTags = ({ tagCategoryId }: { tagCategoryId?: number } = {}) => {
  return useQuery({
    queryKey: ['tags', tagCategoryId],
    queryFn: async () => {
      const response = await api.get<Tag[]>('/tags', {
        params: {
          q: { tag_category_id_eq: tagCategoryId },
        },
      });
      return response.data;
    },
  });
};
